import { autoinject } from "aurelia-framework";

/**
 * Represents the header of a modal.
 */
@autoinject
export class ModalHeaderCustomElement
{
}
